module.exports = __webpack_public_path__ + "img/two-way-arrow.757e30c2.svg";